import { render, staticRenderFns } from "./MultSetting.vue?vue&type=template&id=453f724b&scoped=true"
import script from "./MultSetting.vue?vue&type=script&lang=js"
export * from "./MultSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f724b",
  null
  
)

export default component.exports